import { render, staticRenderFns } from "./Blocking.vue?vue&type=template&id=377a6d2d&"
import script from "./Blocking.vue?vue&type=script&lang=js&"
export * from "./Blocking.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports